var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3213 4.01971L2.11619 17.2258C2.04975 17.2924 2.00178 17.3766 1.97894 17.467L0.515276 23.3418C0.471494 23.5187 0.523462 23.7067 0.652524 23.8358C0.750178 23.9335 0.883239 23.9875 1.01934 23.9875C1.06103 23.9875 1.10367 23.9824 1.14517 23.9719L7.02001 22.5081C7.11157 22.4852 7.19476 22.4374 7.26119 22.371L20.4675 9.16585L15.3213 4.01971Z",
    fill: "rgba(0, 0, 0, 0.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7389 2.21911L22.269 0.749167C21.2865 -0.233271 19.5743 -0.232319 18.593 0.749167L16.7924 2.54976L21.9383 7.69571L23.7389 5.89512C24.2297 5.40456 24.5 4.75164 24.5 4.05721C24.5 3.36278 24.2297 2.70986 23.7389 2.21911Z",
    fill: "rgba(0, 0, 0, 0.6)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.fa5c1406b8edb71772a060d6083eef19.svg";
export { ForwardRef as ReactComponent };